// export const base_url = 'http://127.0.0.1:8000/index'
// export const base_url = 'http://211.144.114.133:8100/index'

export const base_url = 'https://zxadmin.holink.cc/index'
